import React from 'react';
import { FaPassport, FaUserEdit, FaDollarSign } from 'react-icons/fa';

export default [
  {
    key: 'home',
    link: '',
    label: {
      en: 'home',
      es: 'inicio',
    },
  },
  {
    key: 'about',
    link: 'about',
    label: {
      en: 'about me',
      es: 'sobre mi',
    },
  },
  {
    key: 'services',
    label: {
      en: 'services',
      es: 'servicios',
    },
    children: [
      {
        key: 'us_immigration_service',
        link: 'services/us-visas-immigration',
        icon: <FaPassport size="18" />,
        label: {
          en: 'U.S. Visas & Immigration',
          es: 'Inmigración & Visas Americanas',
        },
      },
      {
        key: 'tax_law_service',
        link: 'services/taxes-american-expats',
        icon: <FaDollarSign size="18" />,
        label: {
          en: 'Taxes For American Expats',
          es: 'Impuestos para Expatriados Americanos',
        },
      },
      {
        key: 'legal_translation_service',
        link: 'services/legal-translation',
        icon: <FaUserEdit size="18" />,
        label: {
          en: 'Legal Translation',
          es: 'Traducción Legal',
        },
      },
    ],
  },
  {
    key: 'blog',
    link: 'blog',
    label: {
      en: 'blog',
      es: 'blog',
    },
  },
  {
    key: 'contact',
    link: 'contact',
    label: {
      en: 'contact',
      es: 'contacto',
    },
  },
];
